module.exports = __webpack_public_path__ + "static/media/Online Store 1.e2da625c.png";